export default {
  editForm: {
    title: 'Channel registration form',
    name: 'Internal channel name',
    groupUrl: 'Link to OK group',
    guaranteeLetter: '<0>Letter of confirmation</0> (.pdf)',
    uploadLetter: 'Upload letter',
  },
};
